import React from "react";
import {titleCodes, textCodes} from "../../template_codes/willow/media_room_codes";

function MediaRoom() {
    return (
        <div className="container p-4 lg:p-8 xl:p-10 2xl:p-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2">
                <div className="text-justify pt-8">
                    <p className="text-xs lg:text-lg xl:text-lg pb-2 lowercase font-extralight">{titleCodes.story.title}</p>
                    <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pb-8">{titleCodes.mediaTitle.title}</h1>
                    <p className="tracking-wider pb-4">{textCodes.mediaText.text}</p>
                    <a href="https://www.myanmoreplus.com/2022/08/willow-clothing-elegance-is-timeless/?fbclid=IwAR0rRYCPgKCxf8zdGBw9sCJTj9c8wCZABlh79khxsw7iQzPCwFHrXse7N4E" target="_blank"><p className="btn btn-outline tracking-wider hover:tracking-widest mx-4">Myanmar ❯</p></a>
                    <a href="https://www.myanmore.com/2022/08/elegance-is-timeless-willow-clothing/?fbclid=IwAR06rUxWgZhTvXKxkhYm-SJYTWmcDbGEzUQeUPr5BIfwxGprz_rhRz9N6i8" target="_blank"><p className="btn btn-outline tracking-wider hover:tracking-widest">English ❯</p></a>
                    <p className="py-10"></p>
                </div>
                <div></div>
            </div>
        </div>
    );
}

export default MediaRoom;